(function () {
    'use strict';

    angular.module("imApp").factory("languageLangsService", ['$ihttp', function ($ihttp) {
        let service = {
            listLanguages: function (parms) {
                return $ihttp.post({
                    method: 3350,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3351,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
